import {PageType} from './pages';

export enum NavigationPageType {
    Gap = 'gap',
    Locked = 'locked',
    Page = 'page',
    CopyOnWrite = 'copy_on_write',
}

export interface NavigationPage {
    id?: number;
    slug: string;
    title: string;
    type: NavigationPageType;
    page_type?: PageType;
    has_children: boolean;
    is_highlighted: boolean;
    /* can be true only for the first level nodes */
    is_fixed: boolean;
}
